export class EtmcTrack {
    static cart(cartItems = []) {
        const etmc = (window === null || window === void 0 ? void 0 : window._etmc) || [];
        if (!(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length))
            return;
        const cartInfo = cartItems.map((item) => ({
            item: item.csku,
            quantity: item.quantity,
            price: item.salePrice,
            unique_id: item.id
        }));
        etmc.push(['setOrgId', '536003728']);
        etmc.push([
            'trackCart',
            {
                cart: cartInfo
            }
        ]);
    }
}
